"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let AccountStatementReport = class AccountStatementReport extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_item = new core_1.ComponentValueCache(this, "item", "AccountStatementReport.item");
        this.$$cache_responseType = new core_1.ComponentValueCache(this, "responseType", "AccountStatementReport.responseType");
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    invoices;
    onInvoices(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoices");
    }
    transactionType;
    onTransaction_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("transactionType");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    accounts;
    async $$load_accounts() {
        return this.$fn.fetch('list_account')
            .then(resp => _.orderBy(resp.data, ['inactive', 'account_type', 'name'], ['asc', 'desc', 'asc']));
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    connector;
    async $$load_connector() {
        return this.$fn.resourceProxy({
            url: () => this.$fn.urlFor('report_account_statement', { ...this.item, account: this.item.account.id }),
            useAuth: true,
        }).on('file', args => this.setData('file', args));
    }
    item;
    async $$load_item() {
        return {
            date_from: null,
            date_to: null,
            account: this.accounts ? this.accounts[0] : null,
        };
    }
    file;
    responseType;
    responseTypes;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['accounts', 'formId', 'connector', 'item', 'file', 'responseType', 'responseTypes', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                accounts: null,
                formId: null,
                connector: null,
                item: null,
                file: null,
                responseType: "json",
                responseTypes: ["json",
                    "pdf",
                ],
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "full-screen",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("AccountStatementReport/title", "Account Statement Report"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4648_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_8527427120829392_setData_4652_getActionArgs($event) {
        return {
            path: "item.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_8527427120829392_setData_4654_getActionArgs($event) {
        return {
            path: "item.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_8527427120829392_changed(event, scope) {
        return await this.actions.evh_8527427120829392_changed.executeFromDOM(this, event, scope);
    }
    async act_1729682679878258_script_4656_getActionArgs_value($event) {
        this.withErrorHandler(this.connector.load());
    }
    async act_1729682679878258_script_4656_getActionArgs($event) {
        return {
            value: () => this.act_1729682679878258_script_4656_getActionArgs_value($event),
        };
    }
    async evh_1729682679878258_click(event, scope) {
        return await this.actions.evh_1729682679878258_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4648 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4648_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4647 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4648,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4647],
        });
        const act_2248226175642056_closeModal_4650 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_4649 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_4650,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4649],
        });
        const act_8527427120829392_setData_4652 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8527427120829392_setData_4652_getActionArgs,
            events: [],
        });
        const evh_8527427120829392_changed_4651 = new core_1.actions.EventHandlerImpl({
            action: act_8527427120829392_setData_4652,
            event: "changed",
            displayName: "setData",
        });
        const act_8527427120829392_setData_4654 = new core_1.actions.SetDataAction({
            actionArgs: this.act_8527427120829392_setData_4654_getActionArgs,
            events: [],
        });
        const evh_8527427120829392_changed_4653 = new core_1.actions.EventHandlerImpl({
            action: act_8527427120829392_setData_4654,
            event: "changed",
            displayName: "setData",
        });
        const evh_8527427120829392_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8527427120829392_changed_4651, evh_8527427120829392_changed_4653],
        });
        const act_1729682679878258_script_4656 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1729682679878258_script_4656_getActionArgs,
            events: [],
        });
        const evh_1729682679878258_click_4655 = new core_1.actions.EventHandlerImpl({
            action: act_1729682679878258_script_4656,
            event: "click",
            displayName: "script",
        });
        const evh_1729682679878258_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1729682679878258_click_4655],
        });
        return {
            act_7315092382398562_closeModal_4648,
            evh_7315092382398562_close_4647,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_4650,
            evh_2248226175642056_close_4649,
            evh_2248226175642056_close,
            act_8527427120829392_setData_4652,
            evh_8527427120829392_changed_4651,
            act_8527427120829392_setData_4654,
            evh_8527427120829392_changed_4653,
            evh_8527427120829392_changed,
            act_1729682679878258_script_4656,
            evh_1729682679878258_click_4655,
            evh_1729682679878258_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], AccountStatementReport.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AccountStatementReport.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
        default: null,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], AccountStatementReport.prototype, "invoices", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoices'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AccountStatementReport.prototype, "onInvoices", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], AccountStatementReport.prototype, "transactionType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('transactionType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AccountStatementReport.prototype, "onTransaction_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], AccountStatementReport.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], AccountStatementReport.prototype, "onSize", null);
AccountStatementReport = __decorate([
    (0, vue_property_decorator_1.Component)()
], AccountStatementReport);
exports.default = AccountStatementReport;
vue_property_decorator_1.Vue.component("AccountStatementReport", AccountStatementReport);
